import { createStore } from 'vuex';

function variantesDoFiltro(filtro) {
  const base = filtro.replace(/_exact$/, '');
  return [base, `${base}_exact`];
}

function removeVariantesDeAplicados(filtroAplicados, variantes) {
  return Object.keys(filtroAplicados).reduce((acc, key) => {
    if (!variantes.includes(key)) {
      acc[key] = filtroAplicados[key]
    }
    return acc
  }, {})
}

export const store = createStore({
  state () {
    return {
      filtros: [],
      filtroAplicados: {},
      ordemFiltros: [],
      advancedSettings: {},
      seedInicialSpaAplicado: false
    }
  },
  mutations: {
    setSeedInicialSpaAplicado(state, valor) {
      state.seedInicialSpaAplicado = valor
    },
    setFiltros(state, filtros) {
      state.filtros = filtros
    },
    setFiltrosAplicados(state, filtros) {
      state.filtroAplicados = filtros
    },
    addFiltro(state, filtro) {
      state.filtros.push(filtro)
      if (!state.ordemFiltros.includes(filtro.filtro)) {
        state.ordemFiltros.push(filtro.filtro);
      }
    },
    semearOrdemFiltrosDefault(state, campos) {
      campos
        .filter(campo => campo.default)
        .forEach(campo => {
          if (!state.ordemFiltros.includes(campo.filtro)) {
            state.ordemFiltros.push(campo.filtro);
          }
        });
    },
    addFiltroAplicado(state, filtro) {
      const varianteOposta = filtro.filtro.endsWith('_exact')
        ? filtro.filtro.replace(/_exact$/, '')
        : `${filtro.filtro}_exact`;
      if (varianteOposta in state.filtroAplicados) {
        delete state.filtroAplicados[varianteOposta];
      }
      state.filtroAplicados[filtro.filtro] = filtro.valor
    },
    removeFiltro(state, filtro) {
      const variantes = variantesDoFiltro(filtro);
      state.filtros = state.filtros.filter(f => !variantes.includes(f.filtro))
      state.ordemFiltros = state.ordemFiltros.filter(f => !variantes.includes(f));
      state.filtroAplicados = removeVariantesDeAplicados(state.filtroAplicados, variantes)
    },
    removeFiltroAplicado(state, filtro) {
      const variantes = variantesDoFiltro(filtro);
      state.filtroAplicados = removeVariantesDeAplicados(state.filtroAplicados, variantes)
    },
    limparValoresFiltros (state) {
      state.filtroAplicados = {}
      state.advancedSettings = {}
    },
    setAdvancedSettings(state, settings) {
      state.advancedSettings = settings
    },
    addAdvancedSetting(state, setting) {
      state.advancedSettings[setting.filtro] = setting.value
    },
    removeAdvancedSetting(state, filtro) {
      const { [filtro]:_, ...rest } = state.advancedSettings;
      state.advancedSettings = rest;
    }
  }
})
